import { render } from "./DiagnosisTable.vue?vue&type=template&id=aa6c67c8&ts=true"
import script from "./DiagnosisTable.ts?vue&type=script&lang=ts&external"
export * from "./DiagnosisTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__